import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
// import Index from '../views/index'
// import Index from '@/views/index'

// 公共路由
export const constantRoutes = [
  
  {
    path: '/',
    component: () => import('@/views/index'),
    hidden: true,
  },
  {
    path: '/importNews', //新闻列表
    title:'新闻列表',
    component: () => import('@/views/news/importNews'),
    hidden: true,
  },
  {
    path: '/topic',
    component: () => import('@/views/topic/index'),
    hidden: true,
  },
  {
    path: '/topList',
    component: () => import('@/views/topic/topListModule'),
    hidden: true,
  },
  {
    path: '/topList1',
    component: () => import('@/views/topic/topListNo'),
    hidden: true,
  },
  {
    path: '/topicSpacil',
    component: () => import('@/views/topic/topicSpacil'),
    hidden: true,
  },
  {
    path: '/newsDetail',
    name:'newsDetail',
    component: () => import('@/views/newsDetail'),
    hidden: true,
  },
  {
    path: '/countyLevel', //县区新闻
    title:'县区新闻',
    component: () => import('@/views/countyLevel/index'),
    hidden: true,
  },
  {
    path: '/spacilPage1',
    component: () => import('@/views/spacilPage/index1'),
    hidden: true,
  },{
    path: '/spacilPage2',
    component: () => import('@/views/spacilPage/index2'),
    hidden: true,
  },{
    path: '/spacilPage3',
    component: () => import('@/views/spacilPage/index3'),
    hidden: true,
  },
  {
    path: '/my',
    component: () => import('@/views/my/index'),
    hidden: true,
  },
  {
    path: '/seach',
    component: () => import('@/views/seach/index'),
    hidden: true,
  },
  
  
]
// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})



// WEBPACK FOOTER //
// ./src/router/index.js